import layout from 'app/store/layout';
import { handleUnknownError } from 'app/store/utils';
import { logoutRequest } from 'app/store/auth/actions';

const { setLoader, createToast, setModal } = layout.actions;

export { setLoader, handleUnknownError, createToast, setModal, logoutRequest };
